import React, {useContext, useEffect, useState} from 'react';
import classNames from "classnames";
import PropTypes from 'prop-types';
import {inject, observer} from "mobx-react";
import ym from 'react-yandex-metrika';
import ModalRules from "../modalRules";
import './style.scss';
import {useLogForClickRules} from "../../../helpers/customHooks";
import {IS_SERVER} from "../../../common";

/**
 * Компонент кнопки, вызывающей модалку с правилами фрибета
 *
 * @param {Object} props
 * @param {Number} props.promoId id фрибета, по которому берутся правила
 * @param {Number} props.langId id языка для правил
 * @param {String} [props.title=Правила] Текст кнопки правил
 * @param {String} props.className Дополнительный класс
 * @param {String} props.lang Язык ленда
 * @returns {JSX.Element}
 */
const RulesBtn = inject('appStore', 'kafkaStore')(observer((props) => {
  const {
    kafkaStore: {
      imprintHash
    },
    promoId, langId, title, className, lang } = props;
  const [visibleModal, setVisibleModal] = useState(false);
  const [rulesClick, setRulesClick] = useState(0);
  const classes = classNames('header-wrapper__rules-btn', className);

  const modalHandler = () => {
    setVisibleModal(!visibleModal);
    !IS_SERVER && document.querySelector('html').classList.add('lock-window')
  }
  // const brandName = useContext(brandContext);

  const onRulesClick = () => {
    setRulesClick(rulesClick + 1);
    modalHandler();
    ym('reachGoal', 'rules-btn');
  }

  useLogForClickRules(rulesClick, imprintHash);

  return (
    <>
      <button
        type="button"
        id="rules-btn"
        className={classes}
        onClick={() => onRulesClick()}
      >
        {title}
      </button>
      <ModalRules
        visible={visibleModal}
        onClose={modalHandler}
        promoId={promoId}
        langId={langId}
        lang={lang}
      />
    </>
  )
}));

RulesBtn.propTypes = {
  promoId: PropTypes.number.isRequired,
  langId: PropTypes.number.isRequired,
  title: PropTypes.string,
  className: PropTypes.string
};

RulesBtn.defaultProps = {
  title: 'правила',
};

export default RulesBtn
